

<template>
  <section class="products-section" ref="sectionRef">
    <div class="products-container">
      <h2 class="section-title" :class="{ 'animated slide-left delay-0': sectionVisible }">NOS SOLUTIONS INNOVANTES</h2>
      <p class="section-subtitle" :class="{ 'animated slide-left delay-1': sectionVisible }">Découvrez notre gamme complète de produits ICT pour le marché africain</p>

      <div class="products-grid">
        <div
          v-for="(product, index) in products"
          :key="index"
          :ref="el => { productRefs[index] = el }"
          class="product-card"
          :class="{
            'animated': productVisible[index],
            [getSlideClass(index)]: productVisible[index],
            [`delay-${index % 6}`]: productVisible[index]
          }"
        >
          <div class="product-icon">{{ product.icon }}</div>
          <h3 class="product-title">{{ product.title }}</h3>
          <p class="product-description">{{ product.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { ref, onMounted } from 'vue'
import { useInView } from '@/composables/useInView.js'
export default {
  name: 'Section2View',
  setup() {
const { isVisible: sectionVisible, target: sectionRef } = useInView({
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    })
    const products = [
      { icon: '💳', title: 'CARTE UNIVERSELLE', description: 'Recharge unique pour tous les opérateurs télécoms' },
      { icon: '🌐', title: 'PORTAL WEB', description: 'Plateforme de gestion complète en ligne' },
      { icon: '📱', title: 'SOLUTION USSD', description: 'Menu interactif accessible depuis tous mobiles' },
      { icon: '🔄', title: 'TRANSFERT UNITÉS', description: 'Échange de crédit entre abonnés' },
      { icon: '📲', title: 'APP MOBILE', description: 'Application complète pour smartphones' },
      { icon: '🎁', title: 'CARTES PROMO', description: 'Outils marketing personnalisables' },
      { icon: '💰', title: 'COLLECTE FONDS', description: 'Solutions de financement innovantes' },
      { icon: '🔌', title: 'API INTÉGRATION', description: 'Connectez vos systèmes aux nôtres' },
      { icon: '🛠️', title: 'SOLUTIONS SUR MESURE', description: 'Développements spécifiques à vos besoins' },
      { icon: '📊', title: 'SERVICES SVA', description: 'Services à valeur ajoutée pour opérateurs' },
      { icon: '🧾', title: 'RECEIPTS OFFICIELS', description: 'Gestion des reçus et transactions' },
      { icon: '👑', title: 'PROMO COURONNE', description: 'Système exclusif de bouchons promotionnels' },
    ]

     const productRefs = ref([])
    const productVisible = ref(Array(products.length).fill(false))

    const getSlideClass = (index) => index % 2 === 0 ? 'slide-left' : 'slide-right'

    onMounted(() => {
      productRefs.value.forEach((el, index) => {
        if (!el) return

        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              productVisible.value[index] = true
              observer.unobserve(el)
            }
          },
          {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
          }
        )

        observer.observe(el)
      })
    })

    return {
      products,
      getSlideClass,
      sectionVisible,
      sectionRef,
      productVisible,
      productRefs
    }
  }
}
</script>

<style scoped>
.products-section {
  font-family: 'Public Sans', sans-serif;
  padding: 100px 0;
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  background: url("@/assets/section2/im6.png") no-repeat center center;
  background-size: cover;

}

.products-container {
  width: 100%;
  margin: 0 auto;
}

.section-title {
  font-size: 2.5rem;
  color: white;
  text-align: center;
  margin-bottom: 20px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.section-subtitle {
  font-size: 1.8rem;
  color: white;
  text-align: center;
  margin-bottom: 60px;
  font-weight: 400;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  width: 86%;
  margin-left: 7%;
}

.product-card {
  background-color: #f7f9fb;
  border-radius: 32px;
  padding: 40px 30px;
  text-align: center;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: 'Public Sans', sans-serif;
  color: #000;
  transition: transform 0.3s, box-shadow 0.3s;

}

.product-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.product-icon {
  font-size: 3.5rem;
  margin-bottom: 30px;
}

.product-title {
  color: #000c7a;
  font-size: 1.8rem;
  margin-bottom: 20px;
  font-weight: 700;
  text-transform: uppercase;
}

.product-description {
  color: #000;
  line-height: 1.5;
}

/* Animations */
.animated {
  opacity: 0;
  transform: translateX(0);
  animation-duration: 1.6s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
}

.slide-left {
  transform: translateX(-100px);
  animation-name: slideInLeft;
}

.slide-right {
  transform: translateX(100px);
  animation-name: slideInRight;
}

@keyframes slideInLeft {
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInRight {
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Long Delays */
/*
.delay-0 { animation-delay: 0.6s; }
.delay-1 { animation-delay: 1.2s; }
.delay-2 { animation-delay: 1.8s; }
.delay-3 { animation-delay: 2.4s; }
.delay-4 { animation-delay: 3s; }
.delay-5 { animation-delay: 3.6s; }
.delay-6 { animation-delay: 4.2s; }
.delay-7 { animation-delay: 4.8s; }
.delay-8 { animation-delay: 5.4s; }
.delay-9 { animation-delay: 6s; }
.delay-10 { animation-delay: 6.6s; }
.delay-11 { animation-delay: 7.2s; }
*/

.delay-0  { animation-delay: 0.3s; }
.delay-1  { animation-delay: 0.6s; }
.delay-2  { animation-delay: 0.9s; }
.delay-3  { animation-delay: 1.2s; }
.delay-4  { animation-delay: 1.5s; }
.delay-5  { animation-delay: 1.8s; }
.delay-6  { animation-delay: 2.1s; }
.delay-7  { animation-delay: 2.4s; }
.delay-8  { animation-delay: 2.7s; }
.delay-9  { animation-delay: 3.0s; }
.delay-10 { animation-delay: 3.3s; }
.delay-11 { animation-delay: 3.6s; }


/* Responsive */
@media (max-width: 1200px) {
  .products-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 900px) {
  .products-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .products-grid {
    grid-template-columns: 1fr;
  }

  .product-card {
    min-height: 250px;
    padding: 30px 20px;
  }

  .section-title {
    font-size: 2rem;
  }

  .section-subtitle {
    font-size: 1.2rem;
  }
}
</style>
